import { FC } from 'react'
import { Card } from 'antd'
import PerFlexRow from '../FlexRow'
import PerText from '../Text'
import { useTranslation } from 'react-i18next'

export const PerAtAGlance: FC = ({ children }) => {
  const [t] = useTranslation()

  return (
    <>
      <PerText appearance="tile-heading" mb="s">
        {t('appraisalMeeting.stepOverview.atAGlance')}
      </PerText>
      <Card bordered={false}>
        <PerFlexRow justify="space-around" noWrap>
          {children}
        </PerFlexRow>
      </Card>
    </>
  )
}
